function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { StyledAppInstanceBadgeDropdownWrapper, StyledAppInstanceBadgeDropdown } from './ApplicationSwitcher.styles.js';
import { useDropdownMenu } from '@lwt-helix/useDropdownMenu';
import { NavbarContext } from './NavbarContext.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import ApplicationSwitcherAppInstanceDropdown$1 from './ApplicationSwitcherAppInstanceDropdownMenu.js';
/* eslint-disable max-len */

var ApplicationSwitcherAppInstanceDropdown = function ApplicationSwitcherAppInstanceDropdown(_ref) {
  var item = _ref.item,
      getAppItems = _ref.getAppItems,
      menuRef = _ref.menuRef,
      setHighlightedIndex = _ref.setHighlightedIndex,
      highlightedIndex = _ref.highlightedIndex,
      _ref$usePortal = _ref.usePortal,
      usePortal = _ref$usePortal === void 0 ? false : _ref$usePortal;

  var _useDropdownMenu = useDropdownMenu({
    placement: 'bottom-end',
    items: item.appInstances ? item.appInstances : [],
    itemToString: function itemToString(item) {
      return item.label ? item.label : '';
    },
    offset: [0, 8],
    loopItemsOnKeyDown: false,
    closeMenuOnLastItem: true,
    closeMenuOnFirstItem: true,
    resetSelectedItemOnClose: true
  }),
      isOpenInstance = _useDropdownMenu.isOpen,
      getToggleButtonProps = _useDropdownMenu.getToggleButtonProps,
      getMenuProps = _useDropdownMenu.getMenuProps,
      highlightedIndexMenu = _useDropdownMenu.highlightedIndex,
      getItemPropsMenu = _useDropdownMenu.getItemProps,
      setReferenceElement = _useDropdownMenu.setReferenceElement,
      setPopperElement = _useDropdownMenu.setPopperElement,
      attributes = _useDropdownMenu.attributes,
      styles = _useDropdownMenu.styles;

  var itemIndex = getAppItems ? getAppItems().indexOf(item) : -1;

  var _useContext = useContext(NavbarContext),
      setAppInstancesOpen = _useContext.setAppInstancesOpen;

  var getDropdownLabel = function getDropdownLabel() {
    if (item.appInstances && item.appInstances.length > 0) {
      // return the first app instance label that is the default Option
      var defaultAppInstance = item.appInstances.find(function (appInstance) {
        return appInstance.defaultOption;
      });

      if (defaultAppInstance) {
        return defaultAppInstance.label;
      } else {
        return item.appInstances[0].label;
      }
    }
  };

  return React.createElement(StyledAppInstanceBadgeDropdownWrapper, {
    ref: setReferenceElement
  }, React.createElement(StyledAppInstanceBadgeDropdown, Object.assign({
    className: 'helix-app-switcher__item-badge-dropdown',
    tabIndex: -1
  }, getToggleButtonProps({
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setAppInstancesOpen(function (instanceOpen) {
        // if instanceOpen includes item index remove it else add it
        if (instanceOpen && instanceOpen.includes(itemIndex)) {
          return instanceOpen.filter(function (index) {
            return index !== itemIndex;
          });
        } else {
          return [].concat(_toConsumableArray(instanceOpen), [itemIndex]);
        }
      });
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === 'ArrowDown') {
        e.preventDefault();
        e.stopPropagation();
        setAppInstancesOpen(function (instanceOpen) {
          // if instanceOpen includes item index remove it
          // else add it
          if (instanceOpen && instanceOpen.includes(itemIndex) && !isOpenInstance) {
            return [];
          } else {
            if (instanceOpen && !instanceOpen.includes(itemIndex)) {
              return [].concat(_toConsumableArray(instanceOpen), [itemIndex]);
            }
          }
        });
      }
    }
  }, {
    suppressRefError: true
  })), getDropdownLabel(), React.createElement(NavbarHelixIcon, {
    iconName: 'dropdown_open'
  })), usePortal ? ReactDOM.createPortal(React.createElement(ApplicationSwitcherAppInstanceDropdown$1, {
    setPopperElement: setPopperElement,
    isOpenInstance: isOpenInstance,
    getMenuProps: getMenuProps,
    highlightedIndexMenu: highlightedIndexMenu,
    getItemPropsMenu: getItemPropsMenu,
    item: item,
    menuRef: menuRef,
    setHighlightedIndex: setHighlightedIndex,
    highlightedIndex: highlightedIndex,
    attributes: attributes,
    styles: styles,
    setAppInstancesOpen: setAppInstancesOpen
  }), document.body) : React.createElement(ApplicationSwitcherAppInstanceDropdown$1, {
    setPopperElement: setPopperElement,
    isOpenInstance: isOpenInstance,
    getMenuProps: getMenuProps,
    highlightedIndexMenu: highlightedIndexMenu,
    getItemPropsMenu: getItemPropsMenu,
    item: item,
    menuRef: menuRef,
    setHighlightedIndex: setHighlightedIndex,
    highlightedIndex: highlightedIndex,
    attributes: attributes,
    styles: styles,
    setAppInstancesOpen: setAppInstancesOpen
  }));
};

ApplicationSwitcherAppInstanceDropdown.displayName = 'ApplicationSwitcherAppInstanceDropdown';
export { ApplicationSwitcherAppInstanceDropdown as default };